import React, { useState } from "react"
import { Formik } from "formik"
import { emailValidationSchema } from "./validations/courseREgistrationValidationSchemas"
import { boolean, object, ObjectSchema } from "yup"
import { Button, Checkbox, Form, Input, message, notification } from "antd"
import { AntdFormItem } from "../AntdFormItem/AntdFormItem"
import { css } from "@emotion/react"
import { addSubscriberByEmail } from "../../lib/ecomail/addSubscriberByEmail"
import { slugifyTags } from "../../lib/slugifyTags"
import { RegisterStudentCourse } from "./types"
import { event } from "../../lib/ga"

message.config({
  top: 100
})

const listId = 6 //Zájemci ukázkových hodin kurzů at Ecomail

export const SampleCourseVideoForm = ({ courseName, courseSlug, courseRegistrationUrl, sampleCourseVideoUrl }: Props) => {
  const [isSend, setIsSend] = useState(false)
  const [form] = Form.useForm()

  const initialValues: SampleCourseVideoFormValues = {
    email: "",
    newsletterAgreement: false
  }

  const validationSchema: ObjectSchema<SampleCourseVideoFormValues> = object().shape({
    email: emailValidationSchema,
    newsletterAgreement: boolean().required("Zatrhněte")
  })

  return (
    <Formik<SampleCourseVideoFormValues>
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        setSubmitting(true)

        await addSubscriberByEmail(
          values.email,
          slugifyTags([
            courseName,
            courseSlug,
            "krouzky",
            "registrace ukazkove hodiny",
            courseRegistrationUrl,
            sampleCourseVideoUrl,
            ...(values.newsletterAgreement ? ["newsletterAgreement"] : [])
          ]),
          undefined,
          true,
          undefined,
          listId
        )
          .then(() => {
            event({
              action: "register",
              category: "sample course",
              label: courseSlug,
              value: 0
            })

            notification.success({
              message: "Registrace do ukázkové hodiny",
              description: "Zkontrolujte si svou e-mailovou schránku.",
              duration: 15
            })

            setIsSend(true)
          })
          .catch((err) => {
            console.error(err)

            notification.error({
              message: "Registrace do ukázkové hodiny",
              description: `Omlouváme se, nastala chyba. Děkujeme za pochopení.`,
              duration: 0
            })
          })

        setSubmitting(false)

        form.resetFields()

        resetForm({
          values: initialValues
        })
      }}>
      {({ values, handleSubmit, handleChange, setFieldValue, handleBlur, touched, errors, isValidating, isSubmitting, resetForm }) => (
        <Form form={form}>
          <div
            css={css`
              display: flex;
              flex-direction: column;
              margin-bottom: 10px;

              .ant-row {
                justify-content: center;
              }
            `}>
            <AntdFormItem<SampleCourseVideoFormValues>
              name="email"
              label="Email"
              errors={errors}
              touched={touched}
              labelCol={{ span: "auto" }}
              wrapperCol={{ span: 18 }}>
              <Input value={values.email} onChange={handleChange} onBlur={handleBlur} />
            </AntdFormItem>

            <AntdFormItem<RegisterStudentCourse> name="newsletterAgreement" label="" errors={errors} touched={touched} labelCol={{}} wrapperCol={{}}>
              <Checkbox checked={values.newsletterAgreement} onChange={handleChange}>
                Chci dostávat upozornění e-mailem o akcích organizace Vzdělání budoucnosti, z.s.
              </Checkbox>
            </AntdFormItem>

            <Button
              type="primary"
              htmlType="submit"
              onClick={() => handleSubmit()}
              loading={isSubmitting}
              {...(isSubmitting && {
                css: css`
                  point-events: none;
                `
              })}
              css={css`
                width: min-content;
                align-self: center;
                margin-bottom: 10px;
              `}>
              {isSend ? "Odesláno" : "Získejte ukázkovou hodinu zdarma"}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  )
}

interface SampleCourseVideoFormValues {
  email: string
  newsletterAgreement: boolean
}

interface Props {
  courseName: string
  courseSlug: string
  courseRegistrationUrl: string
  sampleCourseVideoUrl: string
}
